export const loginTypes = {
  LOGOUT: 'LOGOUT',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FAILED: 'LOGOUT_FAILED',
  REQUEST: 'LOGIN_REQUEST',
  SUCCESS: 'LOGIN_SUCCESS',
  FAILED: 'LOGIN_FAILED'
};

export const userTypes = {
  ACCEPT_TERMS_REQUEST: 'ACCEPT_TERMS_REQUEST',
  ACCEPT_TERMS_SUCCESS: 'ACCEPT_TERMS_SUCCESS',
  ACCEPT_TERMS_FAILED: 'ACCEPT_TERMS_FAILED',
  CHANGE_PASSWORD_REQUEST: 'CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILED: 'CHANGE_PASSWORD_FAILED',
  RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILED: 'RESET_PASSWORD_FAILED',
};

export const authTypes = {
  RESET_ERROR: 'RESET_ERROR',
  RESET_RESULT_MESSAGE: 'RESET_RESULT_MESSAGE',
  SET_PASSWORD_SECURITY: 'SET_PASSWORD_SECURITY'
};

export const impersonateTypes = {
  REQUEST: 'IMPERSONATE_REQUEST',
  SUCCESS: 'IMPERSONATE_SUCCESS',
  FAILED: 'IMPERSONATE_FAILED',
  ROLLBACK: 'IMPERSONATE_ROLLBACK',
  ROLLBACK_SUCCESS: 'ROLLBACK_SUCCESS',
  PERMISSIONS_ERROR: 'IMPERSONATE_PERMISSIONS_ERROR',
};
